import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApplicationSettings } from 'lib-config';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PublicCookie } from '../models/public-cookie.model';
import { TokenRenewResult } from '../models/token-renew-result.model';
import { UserInfo } from '../models/user-info.model';

@Injectable()
export class OidcSecurityService {
  constructor(private http: HttpClient, private settings: ApplicationSettings){}

  getUserInfo(): Observable<UserInfo>{
    return this.http.get<UserInfo>(this.settings.backendUrlTokenManagerService + "/auth/userInfo").pipe(catchError((_, __) => {
      let userInfo = new UserInfo();
      userInfo.isAuthenticated = false;
      return of(userInfo);
    }));
  }

  tokenStatus(): Observable<PublicCookie> {
    return this.http.get<PublicCookie>(this.settings.backendUrlTokenManagerService + "/auth/tokenstatus")
    .pipe(map(publicCookie => {
      publicCookie.tokenExpiration = new Date(publicCookie.tokenExpiration);
      return publicCookie;
    }),
    catchError((_, __) => {
      let publicCookie = new PublicCookie();
      publicCookie.isAuthenticated = false;
      return of(publicCookie);
    }));
  }

  renewToken(): Observable<TokenRenewResult> {
    return this.http.post<TokenRenewResult>(this.settings.backendUrlTokenManagerService + "/auth/renewToken", null) .pipe(catchError((_, __) => {
      let tokenRenewResult = new TokenRenewResult();
      tokenRenewResult.isError = true;
      return of(tokenRenewResult);
    }));
  }

  authorize(){
    if(this.settings?.backendUrlTokenManagerService) {
      window.location.href = `${this.settings.backendUrlTokenManagerService}/auth/login?returnUrl=${window.location.origin}`;
    }
  }

  logOff(){
    window.location.href = `${this.settings.backendUrlTokenManagerService}/auth/logout`;
  }
}
